import React from "react";
import { Route, Routes } from "react-router-dom";

// Import your components
import DepartmentList from "./Components/department";
import SubDepartmentList from "./Components/subdepartment.js";
import AdminLayout from "./Layout/AdminLayout.jsx";
import AttendanceForm from "./Pages/AttendanceForm.js";
import Dashboard from "./Pages/Dashboard.jsx";
import Holiday from "./Pages/Holiday.js";
import DiagnostiCreate from "./Pages/LeaveApplication.js";
import LeaveApproval from "./Pages/LeaveApproval";
import Leaves from "./Pages/Leaves.js";
import MissingAttendance from "./Pages/MissingAttendance.js";
import MonthlyAttendance from "./Pages/MonthlyAttendance.js";
import WeeklyHoliday from "./Pages/WeeklyHoliday.js";
import Recruitment from "./Components/recruitment.js";
import DiagnosticList from "./Pages/Awardlist.js";
import BackupReset from "./Pages/BackupReset.js";
import LanguageSetup from "./Pages/LanguageSetup.js";
import MessagesTable from "./Pages/Message.js";
import NoticeList from "./Pages/Noticelist.js";
import SentMessagesTable from "./Pages/Sent.js";
import Settings from "./Pages/Setting";
import SetupRulesTable from "./Pages/Setup.js";
import CandidateShortlist from "./Pages/CandidateShortlist.js";
import InterviewList from "./Pages/InterviewList.js";
import CandidateSelection from "./Pages/CandidateSelection.js";
import ClientsTable from "./Pages/ClientsTable.js";
import ProjectsTable from "./Pages/ProjectsTable.js";
import ProjectTasksTable from "./Pages/ProjectTasksTable.js";
import ManageProjects from "./Pages/ManageProject.js";
import CompanyDetailsForm from "./Pages/CompanyDetailsForm.js";
import CompanyList from "./Pages/CompanyList.js";
import DoctorDetailsForm from "./Pages/DoctorDetailsForm.js";
import DoctorList from "./Pages/DoctorList.js";
import StaffDetailsForm from "./Pages/StaffDetailsForm.js";
import StaffList from "./Pages/StaffList.js";
import DiagnosticsBookingList from "./Pages/DiagnosticsBookingList.js";
import DoctorAppointmentList from "./Pages/DoctorAppointmentList.js";
import AppointmentBookingForm from "./Pages/AppointmentBookingForm.js";
import DiagnosticDetail from "./Pages/DiagnosticDetail.js";
import DiagnosticsPendingBooking from "./Pages/DiagnosticsPendingBooking.js";
import DoctorAppointmentListPending from "./Pages/DoctorAppointmentListPending.js";
import LoginPage from "./Pages/Login.js";
import CategoryForm from "./Pages/CategoryForm.js";
import CategoryList from "./Pages/CategoryList.js";
import CompanySidebar from "./Components/CompanySidebar.js";
import DiagnosticsAcceptedBooking from "./Pages/DiagnosticsAcceptedBooking.js";
import DiagnosticsRejectedBooking from "./Pages/DiagnosticsRejectedBooking.js";
import AcceptedAppointmentsList from "./Pages/AcceptedAppointmentsList.js";
import RejectedAppointmentsList from "./Pages/RejectedAppointmentsList.js";
import StaffHistory from "./Pages/StaffHistory.js";
import DiagnosticBookingForm from "./Pages/DiagnosticBookingForm.js";
import CouponsPage from "./Pages/CouponPage.js";
import CreateCoupon from "./Pages/CreateCoupon.js";
import UploadDocuments from "./Pages/UploadDocuments.js";
import DocumentTable from "./Pages/DocumentTable.js";
import CouponHistoryTable from "./Pages/CouponHistoryTable.js";
import CreateProductForm from "./Pages/CreateProduct.js";
import ProductList from "./Pages/ProductList.js";
import BookingList from "./Pages/BookingList.js";
import PendingBookingList from "./Pages/PendingBookingList.js";
import CompletedBookingList from "./Pages/CompletedBookingList .js";
import CancelledBookingList from "./Pages/CancelledBookingList .js";
import UserList from "./Pages/UserList.js";
import CreatePoster from "./Pages/CreatePoster.js";
import CreateCategory from "./Pages/CreateCategory.js";
import PosterList from "./Pages/PosterList.js";
import CreateLogo from "./Pages/CreateLogo.js";
import LogoList from "./Pages/LogoList.js";
import CreateBusinessCard from "./Pages/CreateBusinessCard.js";
import CreatePlan from "./Pages/CreatePlan.js";
import PlanList from "./Pages/PlanList.js";
import UsersPlansList from "./Pages/UsersPlansList.js";
import OrdersList from "./Pages/OrdersList.js";
import PrivacyPolicyForm from "./Pages/PrivacyPolicyForm.js";
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage.js";
import AboutUsFormPage from "./Pages/AboutUsFormPage.js";
import GetAboutUsPage from "./Pages/GetAboutUsPage.js";
import ContactUsPage from "./Pages/ContactUsPage.js";
import GetContactUsPage from "./Pages/GetContactUsPage.js";
import RegisterPage from "./Pages/Register.js";
import GetProfilePage from "./Pages/GetProfilePage.js";
import CreatePosterForm from "./Pages/CreatePosterForm.js";
import CreateBanner from "./Pages/CreateBanner.js";
import UserContactedList from "./Pages/UserContactedList.js";
import ReportedUsers from "./Pages/ReportedUsers.js";
import PaymentList from "./Pages/PaymentList.js";
import RedemptionRequests from "./Pages/RedemptionRequests.js";
import ManageReels from "./Pages/ManageReels.js";
import ManageAudios from "./Pages/ManageAudios.js";
import LogoCategoryManagement from "./Pages/LogoCategoryManagement.js";
import StickerCategoryManagement from "./Pages/StickerCategoryManagement.js";
import StickerManagement from "./Pages/StickerManagement.js";
import WalletSettings from "./Pages/WalletSettings.js";
import AmountSettings from "./Pages/AmountSettings.js";
import BusinessCardCreator from "./Pages/BusinessCardCreator.js";
import BusinessCardList from "./Pages/BusinessCardList.js";
import CelebrationManager from "./Pages/CelebrationManager.js";
import TrendingPosterCategory from "./Pages/Trending/TrendingPosterCategory.js";
import CreateTrendingPoster from "./Pages/Trending/CreateTrendingPoster.js";
import TrendingPosters from "./Pages/Trending/TrendingPosters.js";
import ManageReelCategory from "./Pages/ManageReelCategory.js";
import ManucreatePlan from "./Pages/Trending/ManucreatePlan.js";
import Manuplanlist from "./Pages/Manuplanlist.js";
import StaffLoginPage from "./Pages/StaffLoginPage.js";

import Staff from "./Pages/Staff.js";
import Createstaff from "./Pages/Createstaff.js";
import PendingReels from "./Pages/PendingReels.js";

function App() {
  console.log("app rendered");
  return (
    <Routes>
      {/* Login page rendered outside AdminLayout */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/staff-login" element={<StaffLoginPage />} />
      {/* All other routes inside AdminLayout */}
      <Route
        path="/*"
        element={
          <AdminLayout>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/department" element={<DepartmentList />} />
              <Route path="/subdepartment" element={<SubDepartmentList />} />
              <Route path="/attendanceform" element={<AttendanceForm />} />
              <Route
                path="/monthlyattendance"
                element={<MonthlyAttendance />}
              />
              <Route
                path="/missingattendance"
                element={<MissingAttendance />}
              />
              <Route path="/weeklyholiday" element={<WeeklyHoliday />} />
              <Route path="/holiday" element={<Holiday />} />
              <Route path="/create-diagnostic" element={<DiagnostiCreate />} />
              <Route path="/leaves" element={<Leaves />} />
              <Route path="/leaveapproval" element={<LeaveApproval />} />
              <Route path="/recruitment" element={<Recruitment />} />
              <Route path="/setting" element={<Settings />} />
              <Route path="/languagesetup" element={<LanguageSetup />} />
              <Route path="/backupreset" element={<BackupReset />} />
              <Route path="/diagnosticlist" element={<DiagnosticList />} />
              <Route path="/message" element={<MessagesTable />} />
              <Route path="/noticelist" element={<NoticeList />} />
              <Route path="/sentlist" element={<SentMessagesTable />} />
              <Route path="/setuplist" element={<SetupRulesTable />} />
              <Route
                path="/candidate-shortlist"
                element={<CandidateShortlist />}
              />
              <Route path="/interviewlist" element={<InterviewList />} />
              <Route
                path="/selectedcandidates"
                element={<CandidateSelection />}
              />
              <Route path="/clients" element={<ClientsTable />} />
              <Route path="/projects" element={<ProjectsTable />} />
              <Route path="/task" element={<ProjectTasksTable />} />
              <Route path="/manage-project" element={<ManageProjects />} />
              <Route
                path="/company-register"
                element={<CompanyDetailsForm />}
              />
              <Route path="/companylist" element={<CompanyList />} />
              <Route path="/create-doctor" element={<DoctorDetailsForm />} />
              <Route path="/doctorlist" element={<DoctorList />} />
              <Route path="/staff-details" element={<StaffDetailsForm />} />
              <Route path="/staff" element={<Staff/>} />
               <Route path="/staff/create" element={<Createstaff/>} />
              <Route
                path="/diagnosticslist"
                element={<DiagnosticsBookingList />}
              />
              <Route
                path="/diagnosticsacceptedlist"
                element={<DiagnosticsAcceptedBooking />}
              />
              <Route
                path="/diagnosticsrejectedlist"
                element={<DiagnosticsRejectedBooking />}
              />
              <Route
                path="/doctoracceptedlist"
                element={<AcceptedAppointmentsList />}
              />
              <Route
                path="/doctorrejectedlist"
                element={<RejectedAppointmentsList />}
              />
              <Route
                path="/appintmentlist"
                element={<DoctorAppointmentList />}
              />
              <Route
                path="/appintmentbooking"
                element={<AppointmentBookingForm />}
              />
              <Route
                path="/diagnostic-center/:id"
                element={<DiagnosticDetail />}
              />
              <Route
                path="/diagnosticpending"
                element={<DiagnosticsPendingBooking />}
              />
              <Route
                path="/doctorpendingbookings"
                element={<DoctorAppointmentListPending />}
              />
              <Route path="/categoryform" element={<CategoryForm />} />
              <Route path="/categorylist" element={<CategoryList />} />
              <Route path="/add-product" element={<CreateProductForm />} />
              <Route path="/productlist" element={<ProductList />} />
              <Route path="/allorders" element={<BookingList />} />
              <Route path="/pendingorders" element={<PendingBookingList />} />
              <Route
                path="/completedorders"
                element={<CompletedBookingList />}
              />
              <Route
                path="/cancelledorders"
                element={<CancelledBookingList />}
              />
              <Route path="/companysidebar" element={<CompanySidebar />} />
              <Route
                path="/staff-history/:staffId"
                element={<StaffHistory />}
              />{" "}
              {/* Route for StaffHistory */}
              <Route
                path="/book-diagnostic"
                element={<DiagnosticBookingForm />}
              />
              <Route path="/coupons" element={<CouponsPage />} />
              <Route path="/couponshistory" element={<CouponHistoryTable />} />
              <Route path="/create-coupon" element={<CreateCoupon />} />
              <Route path="/upload-docs" element={<UploadDocuments />} />
              <Route path="/docs" element={<DocumentTable />} />
              <Route path="/users" element={<UserList />} />
              <Route path="/create-category" element={<CreateCategory />} />
              <Route path="/categorylist" element={<CategoryList />} />
              <Route path="/create-poster" element={<CreatePoster />} />
              <Route path="/posterlist" element={<PosterList />} />
              <Route path="/create-logo" element={<CreateLogo />} />
              <Route path="/logolist" element={<LogoList />} />
              <Route
                path="/create-logocategory"
                element={<LogoCategoryManagement />}
              />
              <Route
                path="/create-businesscard"
                element={<CreateBusinessCard />}
              />
              <Route path="/create-plan" element={<CreatePlan />} />
              <Route path="/planlist" element={<PlanList />} />
              {/* <Route path="/manucreate-plan" element={<ManucreatePlan />} /> */}
              <Route path="/manuplanlist" element={<Manuplanlist />} />
              <Route path="/userplanlist" element={<UsersPlansList />} />
              <Route path="/orderlist" element={<OrdersList />} />
              <Route path="/create-privacy" element={<PrivacyPolicyForm />} />
              <Route path="/get-policy" element={<PrivacyPolicyPage />} />
              <Route path="/aboutus" element={<AboutUsFormPage />} />
              <Route path="/getaboutus" element={<GetAboutUsPage />} />
              <Route path="/contactus" element={<ContactUsPage />} />
              <Route path="/getcontactus" element={<GetContactUsPage />} />
              <Route path="/profile" element={<GetProfilePage />} />
              <Route path="/makeposter" element={<CreatePosterForm />} />
              <Route path="/banner" element={<CreateBanner />} />
              <Route
                path="/usercontactedlist"
                element={<UserContactedList />}
              />
              <Route path="/reported-users" element={<ReportedUsers />} />
              <Route path="/paymentlist" element={<PaymentList />} />
              <Route path="/redemptions" element={<RedemptionRequests />} />
              <Route path="/reels" element={<ManageReels />} />
              <Route
                path="/manage-reel-categories"
                element={<ManageReelCategory />}
              />
              <Route path="/pending-reels" element={<PendingReels />} />
              <Route path="/audio" element={<ManageAudios />} />
              <Route
                path="/stickers-category"
                element={<StickerCategoryManagement />}
              />
              <Route path="/create-sticker" element={<StickerManagement />} />
              <Route path="/userwallet" element={<WalletSettings />} />
              <Route path="/amount-config" element={<AmountSettings />} />
              <Route path="/business" element={<BusinessCardCreator />} />
              <Route path="/businesscardlist" element={<BusinessCardList />} />
              <Route path="/celebration" element={<CelebrationManager />} />
              <Route
                path="/create-trending-category"
                element={<TrendingPosterCategory />}
              />
              <Route
                path="/create-trending-posters"
                element={<CreateTrendingPoster />}
              />
              <Route path="/trending-posters" element={<TrendingPosters />} />
            </Routes>
          </AdminLayout>
        }
      />
      <Route path="/register" element={<RegisterPage />} />
    </Routes>
  );
}

export default App;
